import { DEFAULT_AVATAR_LAYER_SELECTION } from '../ui/avatarGeneratorOptions';
import { DEFAULT_SPRITE_COLORS, type AvatarFormValues, type UserProfile } from '../types/user';

const hasDisplayName = (value: string | null | undefined): boolean =>
  Boolean(value && value.trim().length >= 2);

export const createDefaultAvatarFormValues = (): AvatarFormValues => ({
  displayName: '',
  bio: '',
  spriteId: 'hero_01',
  spriteColors: DEFAULT_SPRITE_COLORS,
  avatarLayers: DEFAULT_AVATAR_LAYER_SELECTION,
  avatarMode: 'layers',
  customAvatarId: null,
});

export const toAvatarFormValues = (
  profile: Partial<UserProfile> | null | undefined,
): AvatarFormValues => ({
  ...createDefaultAvatarFormValues(),
  displayName: profile?.displayName ?? '',
  bio: profile?.bio ?? '',
  spriteId: profile?.spriteId ?? 'hero_01',
  spriteColors: profile?.spriteColors ?? DEFAULT_SPRITE_COLORS,
  avatarLayers: profile?.avatarLayers ?? DEFAULT_AVATAR_LAYER_SELECTION,
  avatarMode: profile?.avatarMode ?? 'layers',
  customAvatarId: profile?.customAvatarId ?? null,
});

export const isUserCharacterDefined = (
  profile: Pick<UserProfile, 'displayName' | 'hasCompletedCharacterSetup'> | null,
): boolean => hasDisplayName(profile?.displayName) && profile?.hasCompletedCharacterSetup === true;
